<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-alert
        type="error"
        v-if="loaded && !editors.length"
      >
        {{ $t('error_no_editor_to_assign') }}
      </v-alert>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
            <v-checkbox
                v-for="editor in editors"
                :key="editor.id"
                :value="editor.id"
                v-model="form.editorIds"
                :label="editor.name"
                hide-details
            ></v-checkbox>
        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<style scoped>
  .ul {
    list-style: none;
  }
</style>
<script>
  import { mapActions, mapState } from 'vuex';

  import { editorsService } from '../../../utils/services/editors.service';

  export default {
    name: 'EditorListModal',
    data() {
      return {
        loaded: false,
        stored: null,
        editors: [],
        form: {
          editorIds: [],
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      async fetchEditor() {
        return editorsService.index({
          filters: {
            editorGroupId: 0,
          },
        })
        .then(response => {
            this.editors = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

    },
    async created() {
      this.loadingModal(true);
      await this.fetchEditor();
      this.loadingModal(false);
      this.loaded = true;
    },
  };
</script>
